import { render } from "./OrderDetailsPurchase.vue?vue&type=template&id=5737a98e&scoped=true"
import script from "./OrderDetailsPurchase.vue?vue&type=script&lang=js"
export * from "./OrderDetailsPurchase.vue?vue&type=script&lang=js"

import "./OrderDetailsPurchase.vue?vue&type=style&index=0&id=5737a98e&lang=scss"
import "./OrderDetailsPurchase.vue?vue&type=style&index=1&id=5737a98e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5737a98e"]])

export default __exports__